export enum BonusSettlementSupplierStatus {
    Open = 'OPEN',
    PartiallySent = 'PARTIALLY_SENT',
    Sent = 'SENT',
    AutomaticallySent = 'AUTOMATICALLY_SENT',
    Completed = 'COMPLETED',
    Reclaimed = 'RECLAIMED',
}

const translationObject: { [Key in BonusSettlementSupplierStatus]: string } = {
    [BonusSettlementSupplierStatus.Open]: 'app.bonusSettlementSupplier.status.open',
    [BonusSettlementSupplierStatus.PartiallySent]: 'app.bonusSettlementSupplier.status.partiallySent',
    [BonusSettlementSupplierStatus.Sent]: 'app.bonusSettlementSupplier.status.sent',
    [BonusSettlementSupplierStatus.AutomaticallySent]: 'app.bonusSettlementSupplier.status.automaticallySent',
    [BonusSettlementSupplierStatus.Completed]: 'app.bonusSettlementSupplier.status.completed',
    [BonusSettlementSupplierStatus.Reclaimed]: 'app.bonusSettlementSupplier.status.reclaimed',
};

export const getBonusSettlementSupplierTranslationId = (status?: BonusSettlementSupplierStatus): string => {
    return (status && translationObject[status]) || 'app.bonusSettlementSupplier.status.open';
};
